module.exports = __webpack_public_path__ + "static/media/leadProjects.a5cfe07f.png";